/**
 * The portal's navigable pages, in one place.
 *
 * Mirrors src/routes/AppRoutes.js — keep the two in step when routes change.
 * Consumed by the Cammy sitemap popover; the sidebar could read from it too.
 */

export const SITE_MAP = [
  {
    title: "Workspace",
    links: [
      {
        id: "cases",
        label: "Cases",
        path: "/redesign/cases",
        description: "Inspection queue and damage reports",
      },
      {
        id: "people",
        label: "Users",
        path: "/redesign/people",
        description: "Users, roles and access levels",
      },
      {
        id: "property-cases",
        label: "Property Cases",
        path: "/property-cases",
        description: "Property inspection queue and damage reports",
      },
    ],
  },
  {
    title: "Coming soon",
    links: [
      {
        id: "home",
        label: "Home",
        description: "Dashboard and daily summary",
        disabled: true,
      },
      {
        id: "analytics",
        label: "Analytics",
        description: "Trends across inspections",
        disabled: true,
      },
    ],
  },
  {
    title: "Public",
    links: [
      {
        id: "landing",
        label: "Landing page",
        path: "/",
        description: "Marketing entry point",
      },
    ],
  },
];

export default SITE_MAP;
